"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.StringLiteral = exports.DecimalLiteral = exports.IntegerLiteral = exports.BooleanLiteral = exports.Literal = void 0;
var expression_1 = require("./expression");
var Literal = /** @class */ (function (_super) {
    __extends(Literal, _super);
    function Literal(json) {
        var _this = _super.call(this, json) || this;
        _this.valueType = json.valueType;
        _this.value = json.value;
        return _this;
    }
    Literal.from = function (json) {
        switch (json.valueType) {
            case '{urn:hl7-org:elm-types:r1}Boolean':
                return new BooleanLiteral(json);
            case '{urn:hl7-org:elm-types:r1}Integer':
                return new IntegerLiteral(json);
            case '{urn:hl7-org:elm-types:r1}Decimal':
                return new DecimalLiteral(json);
            case '{urn:hl7-org:elm-types:r1}String':
                return new StringLiteral(json);
            default:
                return new Literal(json);
        }
    };
    Literal.prototype.exec = function (_ctx) {
        return this.value;
    };
    return Literal;
}(expression_1.Expression));
exports.Literal = Literal;
// The following are not defined in ELM, but helpful for execution
var BooleanLiteral = /** @class */ (function (_super) {
    __extends(BooleanLiteral, _super);
    function BooleanLiteral(json) {
        var _this = _super.call(this, json) || this;
        _this.value = _this.value === 'true';
        return _this;
    }
    Object.defineProperty(BooleanLiteral.prototype, "isBooleanLiteral", {
        // Define a simple getter to allow type-checking of this class without instanceof
        // and in a way that survives minification (as opposed to checking constructor.name)
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    BooleanLiteral.prototype.exec = function (_ctx) {
        return this.value;
    };
    return BooleanLiteral;
}(Literal));
exports.BooleanLiteral = BooleanLiteral;
var IntegerLiteral = /** @class */ (function (_super) {
    __extends(IntegerLiteral, _super);
    function IntegerLiteral(json) {
        var _this = _super.call(this, json) || this;
        _this.value = parseInt(_this.value, 10);
        return _this;
    }
    Object.defineProperty(IntegerLiteral.prototype, "isIntegerLiteral", {
        // Define a simple getter to allow type-checking of this class without instanceof
        // and in a way that survives minification (as opposed to checking constructor.name)
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    IntegerLiteral.prototype.exec = function (_ctx) {
        return this.value;
    };
    return IntegerLiteral;
}(Literal));
exports.IntegerLiteral = IntegerLiteral;
var DecimalLiteral = /** @class */ (function (_super) {
    __extends(DecimalLiteral, _super);
    function DecimalLiteral(json) {
        var _this = _super.call(this, json) || this;
        _this.value = parseFloat(_this.value);
        return _this;
    }
    Object.defineProperty(DecimalLiteral.prototype, "isDecimalLiteral", {
        // Define a simple getter to allow type-checking of this class without instanceof
        // and in a way that survives minification (as opposed to checking constructor.name)
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    DecimalLiteral.prototype.exec = function (_ctx) {
        return this.value;
    };
    return DecimalLiteral;
}(Literal));
exports.DecimalLiteral = DecimalLiteral;
var StringLiteral = /** @class */ (function (_super) {
    __extends(StringLiteral, _super);
    function StringLiteral(json) {
        return _super.call(this, json) || this;
    }
    Object.defineProperty(StringLiteral.prototype, "isStringLiteral", {
        // Define a simple getter to allow type-checking of this class without instanceof
        // and in a way that survives minification (as opposed to checking constructor.name)
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    StringLiteral.prototype.exec = function (_ctx) {
        // TODO: Remove these replacements when CQL-to-ELM fixes bug: https://github.com/cqframework/clinical_quality_language/issues/82
        return this.value.replace(/\\'/g, "'").replace(/\\"/g, '"');
    };
    return StringLiteral;
}(Literal));
exports.StringLiteral = StringLiteral;
//# sourceMappingURL=literal.js.map